import type { AxiosError } from "axios";

import { sleep } from "@/common/utils";

import type { ApiResponse } from "./types";

export const REPLICATION_DELAY = 100;

/**
 * This executes a request-await-return cycle.
 *
 * It's used to stop further script execution, until
 * the processed request data has (hopefully) replicated to all DB servers.
 * Making sure you actually can query the data from the backend,
 * after the request.
 *
 * **replication could be slow, and hence this won't always work
 */
export const withReplicationDelay = async <T>(
  cb: () => T,
  delay = REPLICATION_DELAY
): Promise<T> => {
  const returnValue = cb();

  await sleep(delay);

  return returnValue;
};

/**
 * Extract the error message from an axios error
 */
export function getErrorMessage<T>(error: AxiosError<ApiResponse<T>>): string {
  if (error.response?.data.message) {
    return error.response.data.message.toLowerCase();
  }

  return error.response?.status.toString() ?? "";
}
